// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"25e9886a","732":"10743d7e","977":"bf246dc8"}[chunkId] + ".chunk.js";
};